import { render, staticRenderFns } from "./SPQSvg.vue?vue&type=template&id=24813b1f&"
import script from "./SPQSvg.vue?vue&type=script&lang=ts&"
export * from "./SPQSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports